import React from "react";
import { Cell } from "@sonder/ui/source/styled/fragments/Table";

export const TeamHeaderRow = () => {
  return (
    <>
      <Cell rowStart>Name</Cell>
      <Cell>Email</Cell>
      <Cell>Squads</Cell>
      <Cell>Permissions</Cell>
      <Cell rowEnd />
    </>
  );
};
